var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#efefef !important","z-index":"2","min-height":"28px"}},[_c('DateBar',{staticClass:"bar",attrs:{"display-start-date":_vm.dateBarDisplayStartDate,"display-end-date":_vm.dateBarDisplayEndDate,"start-date":_vm.delivery.startTime,"end-date":_vm.delivery.endTime,"full":""}},[_c('div',{staticClass:"delivery-bar"})]),(!_vm.creatingStyles)?_vm._l((_vm.duplicateRanges),function(item,index){return _c('div',{key:index,staticClass:"duplicate",style:({
        left: _vm.duplicateRangeStyles[index]
          ? _vm.duplicateRangeStyles[index].left
          : 0,
        width: _vm.duplicateRangeStyles[index]
          ? _vm.duplicateRangeStyles[index].width
          : 0,
        'z-index': index + 4,
      })})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }